var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductCarRental = function SvgProductCarRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.5C3.5 9.22386 3.72386 9 4 9H5C5.55228 9 6 9.44772 6 10V10.5C6 10.7761 5.77614 11 5.5 11H4C3.72386 11 3.5 10.7761 3.5 10.5V9.5Z",
    fill: "#44B50C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.5C20.5 9.22386 20.2761 9 20 9H19C18.4477 9 18 9.44772 18 10V10.5C18 10.7761 18.2239 11 18.5 11H20C20.2761 11 20.5 10.7761 20.5 10.5V9.5Z",
    fill: "#44B50C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36955 6.15226C7.4446 5.77701 7.86435 5.5 8.35792 5.5H15.6421C16.1357 5.5 16.5554 5.77701 16.6305 6.15226L17.5 10.5H6.5L7.36955 6.15226Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 11.5H5.5L6.52078 6.29685C6.66715 5.55076 7.48579 5 8.44841 5H15.5516C16.5142 5 17.3328 5.55076 17.4792 6.29685L18.5 11.5ZM7.48459 6.41313C7.55778 6.04008 7.9671 5.76471 8.44841 5.76471H15.5516C16.0329 5.76471 16.4422 6.04009 16.5154 6.41313L17.3633 10.7353H6.63665L7.48459 6.41313Z",
    fill: "#44B50C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5H8V18.5C8 18.7761 7.77614 19 7.5 19H5.5C5.22386 19 5 18.7761 5 18.5V16.5Z",
    fill: "#44B50C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H19V18.5C19 18.7761 18.7761 19 18.5 19H16.5C16.2239 19 16 18.7761 16 18.5V16Z",
    fill: "#44B50C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86761 12.3575C4.94237 11.3109 5.81326 10.5 6.86253 10.5H17.1381C18.1873 10.5 19.0582 11.3109 19.133 12.3575L19.4238 16.4288C19.4651 17.0076 19.0067 17.5 18.4263 17.5H5.57427C4.99393 17.5 4.53546 17.0076 4.57681 16.4288L4.86761 12.3575Z",
    fill: "#59CF1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5C7.5 13.0523 7.05228 13.5 6.5 13.5C5.94772 13.5 5.5 13.0523 5.5 12.5C5.5 11.9477 5.94772 11.5 6.5 11.5C7.05228 11.5 7.5 11.9477 7.5 12.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5C18.5 13.0523 18.0523 13.5 17.5 13.5C16.9477 13.5 16.5 13.0523 16.5 12.5C16.5 11.9477 16.9477 11.5 17.5 11.5C18.0523 11.5 18.5 11.9477 18.5 12.5Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.5C9 12.2239 9.22386 12 9.5 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7761 14.7761 13 14.5 13H9.5C9.22386 13 9 12.7761 9 12.5Z",
    fill: "#44B50C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5C10.5 15.2239 10.7239 15 11 15H13C13.2761 15 13.5 15.2239 13.5 15.5V16C13.5 16.2761 13.2761 16.5 13 16.5H11C10.7239 16.5 10.5 16.2761 10.5 16V15.5Z",
    fill: "#FF9800"
  })));
};
export default SvgProductCarRental;